module.exports = __webpack_public_path__ + "img/middle.8fa5d81a.jpeg";